import React from "react";
import { cn } from "@/lib/utils";
import { limitationStatus } from "@/lib/limitation";
import { AlertTriangle, Clock } from "lucide-react";

// Static, reduced-motion-safe limitation chip. Renders nothing when no
// limitation date is set. Optional onClick (e.g. open the Limitation Clock
// assessment) — it never duplicates the assessment itself.
export function LimitationBadge({ limitationDate, verified = false, onClick, className, size = "sm" }) {
  const s = limitationStatus(limitationDate, { verified });
  if (!s) return null;
  const alert = s.isCritical || s.isExpired;
  const Icon = alert ? AlertTriangle : Clock;
  const pad = size === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]";
  const Tag = onClick ? "button" : "span";
  return (
    <Tag
      {...(onClick ? { onClick: (e) => { e.stopPropagation(); onClick(e); }, type: "button" } : {})}
      data-testid={`limitation-badge-${s.band.toLowerCase()}`}
      title={`Limitation ${s.band} · ${s.basis}${s.verified ? "" : " (manually entered, not rule-derived)"}`}
      className={cn(
        "inline-flex items-center gap-1 rounded-full font-medium whitespace-nowrap",
        pad, onClick && "transition-opacity hover:opacity-80 cursor-pointer", className
      )}
      style={{ color: s.color, background: `${s.color}14`, border: `1px ${s.verified ? "solid" : "dashed"} ${s.color}55` }}
    >
      <Icon className="h-3 w-3" />{s.label}
    </Tag>
  );
}
